import React, { CSSProperties, useEffect, useState } from "react";
import { AthleteDTO } from "../../interfaces/AthletesDTO";
import { TimeDTO } from "../../interfaces/TimeDTO";
import "./styles/displayresultrowstyle.css";
import { formatTime } from "../../services/timeHandler";
import { useDisplays } from "../../services/displayservices/DisplayProvider";
import { DisplayConfigDTO } from "../../interfaces/DistplayConfigDTO";
interface Props {
  athlete: AthleteDTO;
  time: TimeDTO;
  timeformat: string;
  isResult: boolean;
}
const DisplayResultRow = ({ athlete, time, timeformat,isResult }: Props) => {
  const {display,getDisplayProperty} = useDisplays();
  const [forceRerender, setForceReRender] = useState<number>(0);

  const getStyle = <K extends keyof DisplayConfigDTO>(properytName:K):CSSProperties => {

    let dispPropert = getDisplayProperty(properytName);
    let hei = getDisplayProperty("LineHeight");
    let cs:CSSProperties;
    if (dispPropert === null){
      cs = {
        display: "none"
      }
    }
    else if (properytName === "LineHeight"){
      let fontSize = getDisplayProperty("FontSize");
      let rescolor = getDisplayProperty("ResultLinesColor");
      let scrollcolor = getDisplayProperty("ScrollLinesColor");
      let wid = getDisplayProperty("Width");
      
      cs = {
      
        fontSize: fontSize + "px",
        backgroundColor: isResult ? rescolor : scrollcolor,
        width: wid + "px",
      }
    }
    else{
      let color = getDisplayProperty("TextColor");
      cs = {
        width: dispPropert + "px",
        lineHeight: hei + "px",
        maxWidth: dispPropert + "px",
        display: parseInt(dispPropert) < 1 ? "none" : "",
        color: color,
      }
    }
    
    return cs;
  };

  useEffect(() => {
    setForceReRender(old => old +1);
  },[display]);
  return (
    <tr className="display-result-row" style={getStyle("LineHeight")}>
      <td className="display-result-col display-result-col-rank"  style={getStyle("RankWidth")}>
        {time.RankClass}
      </td>
      <td className="display-result-col display-result-col-startno" style={getStyle("StartnoWidth")}>
        {athlete.Startno}
      </td>
      <td className="display-result-col display-result-col-name" style={getStyle("NameWidth")}>
        {athlete.FormatedName}
      </td>
      <td className="display-result-col display-result-col-shortname" style={getStyle("ShortNameWidth")}>
        {athlete.FormatedShortName}
      </td>
      <td className="display-result-col display-result-col-club" style={getStyle("TeamWidth")}>
        {athlete.Club}
      </td>
      <td className="display-result-col display-result-col-nation" style={getStyle("NationWidth")}>
        {athlete.Nation}
      </td>
      <td className="display-result-col display-result-col-runtime" style={getStyle("RuntimeWidth")}>
        {formatTime(time.RunTime, timeformat)}
      </td>
      <td className="display-result-col display-result-col-diff" style={getStyle("DiffWidth")}>
        {formatTime(time.DiffClass, timeformat)}
      </td>
      <td className="display-result-col display-result-col-time" style={getStyle("TimeWidth")}>
        {time.RankClass === 1 || !isResult
          ? formatTime(time.RunTime, timeformat)
          : "+" + formatTime(time.DiffClass, timeformat)}
      </td>
    </tr>
  );
};

export default DisplayResultRow;
